import { render } from "./AuthMenu.vue?vue&type=template&id=1268774c"
import script from "./AuthMenu.vue?vue&type=script&lang=js"
export * from "./AuthMenu.vue?vue&type=script&lang=js"
script.render = render

export default script